import React from 'react'
import Box from '@src/components/Box'
import { useTheme } from '@material-ui/core/styles'

const ItemSkeleton = ({ rows = 5 }: { rows?: number }) => {
  const theme = useTheme()

  return (
    <>
      {Array(rows)
        .fill({})
        .map((_, i) => (
          <Box
            key={i}
            bgcolor={theme.palette.grey['50']}
            height={72}
            mb={6}
            borderRadius="borderRadius"
          />
        ))}
    </>
  )
}

export default ItemSkeleton
